module.exports = __webpack_public_path__ + "cry.49e132f2.png";